export const generateRedbookImageUrl = (photoId?: string) => {
  if (!photoId) {
    return '/images/car-image-not-found.svg';
  }
  return `https://vehicle-images.howsafeisyourcar.com.au/hsiyc/car/spec/${photoId}.jpg`;
};
